import { useState } from "react";
import { ArrowRight, Info } from "lucide-react";
import { SAMPLE_CHATS } from "@/lib/config";
import { useStart } from "./useStart";

export const DemoArea = () => {
  const [active, setActive] = useState(SAMPLE_CHATS[0]);
  const start = useStart();
  return (
    <section id="demo" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
      <div className="max-w-2xl mb-10 space-y-3">
        <div className="eyebrow">Sample chats</div>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">See the idea, then try it live.</h2>
        <p className="text-muted-foreground">Fictional conversations with illustrative example replies. Load one into the generator to get real AI suggestions.</p>
      </div>
      <div className="flex gap-2 overflow-x-auto pb-2 mb-6">
        {SAMPLE_CHATS.map((s) => (
          <button key={s.id} data-testid={`demo-scenario-${s.id}`} onClick={() => setActive(s)}
            className={`shrink-0 rounded-full px-4 py-2 text-sm font-medium border transition-colors ${active.id === s.id ? "brand-gradient text-white border-transparent" : "border-border bg-card hover:border-primary/50"}`}>
            {s.title}
          </button>
        ))}
      </div>
      <div className="grid lg:grid-cols-2 gap-5">
        <div className="panel p-6 space-y-3" data-testid="demo-chat-panel">
          <div className="text-xs text-muted-foreground">{active.platform} · fictional</div>
          {active.messages.map((m, i) => (
            <div key={i} className={`rounded-2xl px-4 py-2.5 text-sm max-w-[80%] w-fit ${m.speaker === "me" ? "ml-auto bg-primary text-primary-foreground rounded-br-sm" : "bubble-them rounded-bl-sm"}`}>{m.text}</div>
          ))}
        </div>
        <div className="panel p-6 space-y-3" data-testid="demo-examples-panel">
          <div className="flex items-center gap-2 text-xs font-semibold text-amber-600 dark:text-amber-400">
            <Info className="h-3.5 w-3.5" /> Illustrative examples — not live AI output
          </div>
          {active.examples.map((e) => (
            <div key={e.text} className="rounded-2xl border border-border p-4">
              <div className="text-[11px] uppercase tracking-wider font-semibold text-primary mb-1">{e.label}</div>
              <div className="text-sm">{e.text}</div>
            </div>
          ))}
          <button data-testid="demo-use-sample-button" onClick={() => start(active)} className="w-full mt-2 h-12 rounded-full brand-gradient text-white font-semibold inline-flex items-center justify-center gap-2 hover:opacity-90 transition-opacity">
            Use this chat in the generator <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </section>
  );
};
